/* eslint-disable comma-dangle */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-console */
/* eslint-disable no-invalid-this */
/* eslint-disable space-before-function-paren */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import styles from './auth-guard.css';

class AuthGuard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            isLoading: true
        };
    }

    componentDidMount() {
        this.authenticate();
    }

    authenticate = async () => {
        try {
            const response = await fetch(this.props.authUrl, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.ok) {
                this.setState({
                    isAuthenticated: true,
                    isLoading: false
                });
            } else {
                this.clearCookies();
                window.location.href = this.props.redirectUrl;
            }
        } catch (error) {
            console.error('Authentication error:', error);
            this.clearCookies();
            window.location.href = this.props.redirectUrl;
        }
    };

    clearCookies = () => {
        // Lấy tất cả cookie hiện tại
        const cookies = document.cookie.split(';');
        cookies.forEach(cookie => {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            const expirationDate = 'Thu, 01 Jan 1970 00:00:00 GMT';
            document.cookie = `${name}=;expires=${expirationDate};path=/`;
            document.cookie = `${name}=;expires=${expirationDate};path=/;domain=${window.location.hostname}`;
            document.cookie = `${name}=;expires=${expirationDate};path=/;domain=.${window.location.hostname}`;
        });

        console.log('Đã xóa tất cả cookie trước khi chuyển hướng');
    };

    render() {
        const {isLoading} = this.state;
        const {children} = this.props;

        if (isLoading) {
            return (
                <div className={styles.loadingContainer}>
                    <div className={styles.spinner}></div>
                    <p className={styles.loadingText}>
                        <FormattedMessage
                            defaultMessage="Đang xác thực..."
                            description="Loading text for authentication"
                            id="auth.loading"
                        />
                    </p>
                </div>
            );
        }
        return children;
    }
}

AuthGuard.propTypes = {
    authUrl: PropTypes.string.isRequired,
    redirectUrl: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default AuthGuard;
